export default {
    "Templates": "",
    "Template 1": `<b><u>VITAL SIGNS</u></b><br>
    <b>BP:</b><br>
    <b>HR:</b><br>
    <b>O2:</b><br>
    <b>RR:</b><br>
    <b>Temp:</b><br><br>
    
    <b><u>Physical assessment</u></b><br>
    <b>Neuro:</b> Awake most of the day, alert. Ambulated with assist X 2 to chair.<br><br>
    
    <b>Resp:</b> Lung sounds clear. Occasional productive cough. Oral suction every 2 hours<br><br>
    
    <b>Trach:</b> stoma dry and clear, no drainage<br><br>
    
    <b>Oxygen:</b> 2 liters nasal cannula<br><br>
    
    <b>Cardio:</b> Regular rhythm, Pulses palpable. No peripheral edema.<br><br>
    
    <b>GI:</b> Abdomen soft, nontender. Bowel sounds present all quadrants. No BM this shift.<br><br>
    
    <b>Last BM:</b> last night<br>
    <b>PEG tube feeding:</b> Jevity 1.5 at rate of 50ml/hr, water flushes 30ml every 6hrs. No residual<br>
    <b>PEG tube site/dressing:</b> no redness or drainage, dressing dry and intact<br>
    <b>GU:</b> Voiding regularly throughout shift. Clear yellow urine<br><br>
    
    <b>Skin:</b> Clean, dry, intact. Lotion applied. Position changed regularly.<br><br>
    
    <b>PICC/Dressing-</b> Clean, dry, intact. No redness. No s/s infection, good blood return and flushes easily.<br><br>
    
    <b>Next PICC dressing change due:</b><br><br> 
    
    <b>IV Fluids:</b> D5LR rate at 70 ml/hr<br><br>
    
    <b>IV Antibiotics:</b><br><br>
    
    <b>Notes:</b> physical therapy today, patient walked with walker, well tolerated. Speech therapy tomorrow, etc.
    `
}